import { gql } from '@apollo/client';

/**
 * Data for the supplementary thank-you page:
 * - hasActiveAdditionalHealthPolicy: does the buyer already hold an active additional policy (cross-sell gate)
 * - overflowVoucherStatus: active campaign voucher, used to mention the discount in the CTA copy
 * - checkoutHealthOffer.supplementary: insurer brand + totals for the order-details card
 * - checkoutHealthOfferData: insured person, policy number and coverage start for the order-details card
 */
export const getCrossSellAdditionalInfo = gql`query crossSellAdditionalInfo($offerId: String!) {
  hasActiveAdditionalHealthPolicy(id: $offerId)
  overflowVoucherStatus {
    active
    voucherCode
    voucherValue
    voucherDescription
  }
  checkoutHealthOffer(id: $offerId) {
    supplementary {
      brandName
      total {
        creditCard
        creditCardWithInstallments
        generalTransfer
        generalTransferWithInstallments
      }
    }
  }
  checkoutHealthOfferData(id: $offerId) {
    newPolicyStartDate
    contractor {
      person {
        firstName { value }
        lastName { value }
        birthDate { value }
        phoneNumber { value }
        partnerContactEmail { value }
      }
    }
    insuredPerson {
      firstName { value }
      lastName { value }
      birthDate { value }
      partnerContactEmail { value }
      insuranceNumber { value }
    }
  }
}
`;
